import { getEmoji, getEmojiImageUrl } from '@/utils/emojis'

const EMOJI_CACHE = {}
export function getEmojiElement (name) {
  if (!EMOJI_CACHE[name]) {
    const el = document.createElement('img')
    el.alt = getEmoji(name)
    el.src = getEmojiImageUrl(name)
    el.classList.add('emoji')
    EMOJI_CACHE[name] = el
  }
  return EMOJI_CACHE[name].cloneNode(true)
}
